import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container } from '@mui/material';
import { Link } from 'react-scroll';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import logo from '../images/logo_1.jpeg';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = ['Home', 'About', 'Gallery', 'Services', 'Projects', 'Contact'];

  return (
    <AppBar 
      position="sticky" 
      elevation={scrolled ? 4 : 0} 
      sx={{ 
        bgcolor: 'rgba(255,255,255,0.95)', 
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid',
        borderColor: scrolled ? 'transparent' : '#eaeaea',
        transition: 'all 0.3s ease'
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ height: scrolled ? 64 : 80, transition: 'all 0.3s' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, cursor: 'pointer', gap: 1 }}>
            <Box component="img" src={logo} alt="Logo" sx={{ height: scrolled ? 40 : 50, width: 'auto' }} />
            <Box>
              {/* <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 900, lineHeight: 1, letterSpacing: '-0.5px' }}>
                GREEN & BLUE
              </Typography> */}
              <Typography
  variant="h6"
  sx={{
    fontWeight: 1000,
    lineHeight: 1,
    letterSpacing: "-0.5px",
    fontSize: { xs: "1.5rem", md: "1.9rem" },
  }}
>
  <span style={{ color: "#66bb6a" }}>GREEN</span> 
  <span style={{ color: "gray" }}>&</span>
  <span style={{ color: "#0a2540" }}>BLUE</span>
</Typography>

              <Typography variant="caption" sx={{ color: 'text.secondary', letterSpacing: 3, fontSize: '1.0rem' }}>
                SOLUTIONS
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            {navItems.map((item) => (
              <Link key={item} to={item.toLowerCase()} smooth={true} duration={500} offset={-70}>
                <Button sx={{ color: 'text.primary', mx: 0.75, '&:hover': { color: 'secondary.main' } }}>
                  {item}
                </Button>
              </Link>
            ))}
            {/* <Link to="contact" smooth={true} offset={-70}>
              <Button variant="contained" color="primary" sx={{ ml: 2 }}>
                Get Quote
              </Button>
            </Link> */}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;